export default __webpack_public_path__ + "static/media/STL-AGM-Notice.10828454.pdf";